import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/product-item-eans";

const setTokenAllHeaders = async () => {
    const token = localStorage.getItem("adminToken");
    axios.defaults.headers.common["Authorization"] = token;
};

const list = async ({
    limit = 15,
    page = 0,
    search = "",
    searchEan = "",
    searchRef = "",
    productItemId = null,
    status = null
}) => {
    await setTokenAllHeaders();
    const response = await axios.get(BASE_URL, {
        params: { limit, page, search, searchEan, searchRef, productItemId, status },
    });
    return response.data;
};

const getByItemId = async (productItemId) => {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/item/${productItemId}`);
    return response.data;
};

const saveBulk = async (payload) => {
    await setTokenAllHeaders();
    const response = await axios.post(`${BASE_URL}/save`, payload);
    return response.data;
};

const importBulk = async (formData) => {
    await setTokenAllHeaders();
    const response = await axios.post(`${BASE_URL}/import`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

const updateStatus = async (id, status) => {
    await setTokenAllHeaders();
    const response = await axios.post(`${BASE_URL}/${id}/status`, { status });
    return response.data;
};

const createSingle = async (payload) => {
    await setTokenAllHeaders();
    const response = await axios.post(BASE_URL, payload);
    return response.data;
};

const setPrimary = async (id) => {
    await setTokenAllHeaders();
    const response = await axios.post(`${BASE_URL}/${id}/primary`);
    return response.data;
};

export default {
    list,
    getByItemId,
    saveBulk,
    importBulk,
    updateStatus,
    createSingle,
    setPrimary,
};